/**
 * @packageDocumentation
 * @module api.functional.items.categories
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponseArraystring } from "../../../structures/ServiceResponseArraystring";

/**
 * @controller ItemController.getCategories
 * @path GET /items/categories
 * @accessor api.functional.items.categories.getCategories
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getCategories(
  connection: IConnection,
): Promise<getCategories.Output> {
  return PlainFetcher.fetch(connection, {
    ...getCategories.METADATA,
    template: getCategories.METADATA.path,
    path: getCategories.path(),
  });
}
export namespace getCategories {
  export type Output = ServiceResponseArraystring;

  export const METADATA = {
    method: "GET",
    path: "/items/categories",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/items/categories";
}
